<template>
  <div class="ProductEssentialOptions FormItem">
    <div class="ProductEssentialOptions-Description">
      <input
        type="checkbox"
        :id="essentialOption.productId"
        :value="essentialOption.name"
        name="option"
        v-model="selected"
        @click="toggleOptionCart"
      />
      <label :for="essentialOption.productId">
        <div class="wrapper" :class="{'active': selected}">
          <div class="img-wrapper">
            <img :src="essentialOption.thumbnail" />
          </div>
          <div class="title">{{ essentialOption.name }}</div>
            
          <div @click.prevent>
            <ToolTip  :text="essentialOption.shortDescription"  :classProps="classProps" ToolText="En savoir plus"></ToolTip>
          </div>

          <div class="bottom-wrapper">
            <div class="ButtonProduct zeborne">
              <span>Quantité :</span>
              <select
                  autocomplete="off"
                  name="quantity-product"
                  v-model="quantity"
              >
                <option :value="value" :id="value" v-for="(value, index) in quantityDefault" :key="index">{{
                  value
                  }}</option>
              </select>
            </div>
            <div class="ProductEssentialOptions-Price">  
              <!-- PROMO PRICE -->
              <div v-if="essentialOption.specialPrice !== false" class="ProductPrice-infoPrice">
                <p class="priceBig" :inner-html.prop="essentialOption.specialPrice | formatPrice(2)"></p>
                <div class="ProductPrice-infoOriginal" v-if="essentialOption.price">
                  <p class="priceOriginal" :inner-html.prop="essentialOption.price | formatPrice(2)"></p>
                </div>
              </div>
              <!-- NON PROMO PERCENT -->
              <div v-else class="ProductPrice-infoPrice">
                <p class="priceBig" :inner-html.prop="essentialOption.price  | formatPrice(2)"></p>
              </div>
              <span class="tvaGrey" v-if="essentialOption.tva > 0">TVA {{ essentialOption.tva }}%</span>
            </div>
          </div>
          <div class="tick"></div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import "@/includes/Cart/CartResumeEssentialOptionCard/CartResumeEssentialOptionCard.scss";
import addItemToCartMixin from "@/mixins/actions/cart/addItemToCartMixin.js";
import removeItemToCartMixin from "@/mixins/actions/cart/removeItemToCartMixin.js";
import ToolTip from "@/components/ToolTip/ToolTip.vue";
import EventBus from "@/event-bus";

export default {
  name: "ProductEssentialOptions",

  components: {
    ToolTip,
  },

  mixins: [addItemToCartMixin, removeItemToCartMixin],
  
  props: {
    essentialOption: {
      type: Object,
      required: true,
    },
    classProps: {
      type: String,
      required: false
    },
    preSelected: {
        type: Boolean,
        required: false,
        default: false
    }
  },

  data() {
    return {
      selected: false,
      quantity: 1,
      quantityDefault: 20,
    };
  },

  methods: {
    async toggleOptionCart(e) {
      EventBus.$emit('toggleSpinner')
      
      if (this.selected) {

        try{
          await this.removeItemToCart(this.essentialOption.productId, true, true);
        }catch(error) {
          EventBus.$emit('toggleSpinner')
          console.error(error);
        }
      } else {
        
        try{
          await this.addItemToCart(this.essentialOption.productId, this.quantity);
        }catch(error) {
          console.error(error);
          EventBus.$emit('toggleSpinner')
        }
      }

      EventBus.$emit('toggleSpinner')
    }
  },

  watch: {
    quantity() {   
      if(this.selected){
        this.removeItemToCart(this.essentialOption.productId, true, true, false)
          .then(() => this.addItemToCart(this.essentialOption.productId, this.quantity));
      }
    },
  },

  mounted() {
    this.selected = this.essentialOption.isInCart;

    // When qty changed from CartRecapRowOption on Cart
    EventBus.$on('essentialOption::qtyChanged', (qty, productId) => {
      if(this.essentialOption.productId === productId) {
        this.quantity = qty;
      }
    })

    // When option removed from CartRecapRowOption on Cart
    EventBus.$on('essentialOption::optionRemoved', (productId) => {
      if(this.essentialOption.productId === productId) {
        this.selected = false;
      }
    })
  },

};
</script>

<style lang="scss" scoped>
.wrapper {
  align-items: center;
  border: 1px solid $color-gray-2;
  border-radius: 5px;
  color: $color-text-secondary;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  justify-content: space-between;
  min-height: 210px;
  padding-bottom: 15px;
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;

  .img-wrapper {
    background-color: #FAFAFA;
    padding: 10px;
    width: 100%;
    border-radius: 5px 5px 0 0;
    margin-bottom: 15px;
  }

  .title,
  .bottom-wrapper {
    padding: 0 15px;
  }
  .ButtonProduct {
    select {
      width: 80px;
      margin-right: 0;
      padding-left: 10px;
    }
    span {
      left: 10px;
    }
  }

  .tick {
    align-items: center;
    background: #34a853;
    border-radius: 50%;
    color: #fff;
    display: none;
    height: 15px;
    justify-content: center;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 15px;

    &::after {
      content: "\e906";
      font-family: "icomoon";
      font-size: 10px;
    }
  }

  .picto {
    margin-bottom: 13px;
    height: 70px;
    width: 70px;
  }

  img {
    max-width: 90px;
    height: auto;
  }

  &.active {
    border-width: 2px;
    border-color: #34a853;

    .tick {
      display: flex;
    }
  }

  .desc, .more {
    @include fontSize(11px);
  }
  
  .highlight {
    display: block;
  }

  .highlight, .more {
    color: $color-orange;
  }

  .bottom-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 15px;
  }
}
.FormItem > div,
.FormItem input+label {
  height: 100%;
}
input[type=checkbox]+label {
  padding-left: 0;
  &:before {
    display: none;
  }
}
input[type=checkbox]:checked+label:after {
  display: none;
}
.question-step:nth-child(2) .FormItem:last-child {
  grid-column: auto;
}
</style>